import { TasksHubSection } from './TasksHubSection';
import type { AsyncItemStatus } from 'owa-copilot-async-chat';

/**
 * Maps an async item status to a Tasks Hub section, or `undefined` when it should not be listed.
 */
export default function mapStatusToSection(status: AsyncItemStatus): TasksHubSection | undefined {
    switch (status) {
        case 'Completed':
            return TasksHubSection.ReadyToReview;
        case 'InputRequired':
        case 'Failed':
        case 'Paused':
            return TasksHubSection.NeedsAttention;
        case 'Working':
            return TasksHubSection.InProgress;
        case 'None':
        case 'Canceled':
        default:
            return undefined;
    }
}
